import { render, staticRenderFns } from "./QTabItem.vue?vue&type=template&id=6405afb8&scoped=true"
import script from "./QTabItem.vue?vue&type=script&lang=js"
export * from "./QTabItem.vue?vue&type=script&lang=js"
import style0 from "./QTabItem.vue?vue&type=style&index=0&id=6405afb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405afb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6405afb8')) {
      api.createRecord('6405afb8', component.options)
    } else {
      api.reload('6405afb8', component.options)
    }
    module.hot.accept("./QTabItem.vue?vue&type=template&id=6405afb8&scoped=true", function () {
      api.rerender('6405afb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/q-tabs/QTabItem.vue"
export default component.exports